import { sendToApi } from 'api/client'
import { DesignChannel } from 'components/NewFileModal/Types'
import { TextChannelKey } from 'types'

export interface WizardDraft {
  id: number
  workspace_id: number
  step: number
  completed_all: boolean
  values: any
  channel: TextChannelKey | DesignChannel
  updated_at: string
  created_at: string
}

export const WizardDraftClient = {
  createDraft: async (wizardDraft: Omit<WizardDraft, 'id' | 'updated_at' | 'created_at'>) => {
    const res = await sendToApi<WizardDraft>(`/wizard_drafts`, {
      method: 'post',
      body: wizardDraft,
    })

    return res
  },

  getAllDrafts: async (workspaceId: number) => {
    const res = await sendToApi<WizardDraft[]>(`/wizard_drafts?workspace_id=${workspaceId}`, {
      method: 'get',
    })

    return res
  },

  updateDraft: async (id: number, updatedWizardDraft: Partial<WizardDraft>) => {
    const res = await sendToApi<WizardDraft>(`/wizard_drafts/${id}`, {
      method: 'put',
      body: updatedWizardDraft,
    })

    return res
  },

  deleteDraft: async (id: number) => {
    const res = await sendToApi<void>(`/wizard_drafts/${id}`, {
      method: 'delete',
    })

    return res
  },
}
